// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon__2qeSS"};


//////////////////
// WEBPACK FOOTER
// ./components/icon/icon.css
// module id = mw+q
// module chunks = 0